module.exports = __webpack_public_path__ + "img/logo-web3pays.d8638778.svg";